exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_localizerApp {\n  padding: 40px;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  overflow: auto;\n}", ""]);

